import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class CustomDialogComponent extends Vue {
    @Prop()
    title: string;

    @Prop()
    message: string;

    @Prop()
    prompt: object;

    @Prop()
    options: object;

    @Prop()
    ok: boolean | string | object;

    @Prop()
    cancel: boolean | string | object;

    @Prop()
    stackButtons: boolean;

    @Prop()
    preventClose: boolean;

    @Prop()
    noEscDismiss: boolean;

    @Prop()
    noBackdropDismiss: boolean;

    @Prop()
    noRefocus: boolean;

    @Prop()
    position: string;

    @Prop()
    color: string;

    @Prop()
    value: boolean;

    title_: string | null = null;
    message_: string | null = null;
    ok_: boolean | string | object | null = null;
    cancel_: boolean | string | object | null = null;
    onOkCallback: Function | null = null;
    onCancelOrHideCallback: Function | null = null;

    show(options: {
        title?: string;
        message?: string;
        ok?: boolean | string | object;
        cancel?: boolean | string | object;
        onOkCallback?: Function;
        onCancelOrHideCallback?: Function;
    }): void {
        this.clearData();
        this.title_ = options.title || null;
        this.message_ = options.message || null;
        this.ok_ = options.ok || true;
        this.cancel_ = options.cancel || null;
        this.onOkCallback = options.onOkCallback || null;
        this.onCancelOrHideCallback = options.onCancelOrHideCallback || null;
        (<any>this.$refs).dialog.show();
    }

    clearData(): void {
        this.title_ = null;
        this.message_ = null;
        this.ok_ = null;
        this.cancel_ = null;
        this.onOkCallback = null;
        this.onCancelOrHideCallback = null;
    }

    onOk(): void {
        if (this.onOkCallback instanceof Function) {
            this.onOkCallback();
        }
        this.$emit('ok');
    }

    onCancel(): void {
        if (this.onCancelOrHideCallback instanceof Function) {
            this.onCancelOrHideCallback();
        }
        this.$emit('cancel');
    }

    onShow(): void {
        this.$emit('show');
    }

    onHide(): void {
        this.$emit('hide');
    }
}
